import { useRouter } from 'next/router'
import {
  EventActions,
  EventCategories,
  EventNames,
  sendDigitalDataEvent,
} from '@cinch-nx/shared-analytics'
import { track } from '@cinch-labs/customer-data-segment'
import {
  SectionWithImageV2,
  SectionWithImageV2Props,
} from '@cinch-nx/landing-ui-shared'

const aboutDeliveryPreferCollectionCtaClick = () => {
  const evt = {
    event: {
      name: EventNames.click,
      category: EventCategories.button,
      action: EventActions.navigate,
      label: 'about-delivery-prefer-collection-cta-click',
    },
  }

  sendDigitalDataEvent(evt)
  track('About Delivery - Prefer collection cta', evt)
}

export const SectionWithImageV2Wrapper: React.FC<SectionWithImageV2Props> = (
  props,
) => {
  const router = useRouter()

  const onClickHandler = () => {
    aboutDeliveryPreferCollectionCtaClick()
    router.push('/car-collections')
  }

  return <SectionWithImageV2 onButtonClick={onClickHandler} {...props} />
}
